import { BaseModel } from 'src/app/shared/models/base.model';

export class Partnership extends BaseModel{
    
    public partners_id: number;   
    created_at:any;
    picturePartiner:any;
    nameClub:any;
    namePartner:any;
    destription:any;
    nameService:any;
    descriptionService:any;
    clubBonus:any;
    percentName:any;
    partnerBonus:any;
    khuzelaBonus:any;
    pictureClub:any;

    static fromJsonToObject(jsonData:any):Partnership{
        return Object.assign(new Partnership(),jsonData);
    }

}